const Footer = () => {
  return (
    <>
      <footer className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>REYON Retail Management System &copy; ReyonSoft Solutions</span>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer;